<div class="form-field" [formGroup]="parent" [ngClass]="{'has-error': parent.get(controllerData.controlName).touched
&& parent.get(controllerData.controlName).errors}" role="phoneNumber" [attr.aria-describedby]="controllerData['name']">
  <label [id]="controllerData['name']" [attr.for]="pageName+'-'+controllerData['name']" class="form-label">{{controllerData['label']}}</label>

  <input [formControlName]="controllerData['controlName']"
    [name]="controllerData['name']" type="text"
    [id]="pageName+'-'+controllerData['name']"
    [(ngModel)]="controllerData.value" aria-invalid="false"
    [placeholder]="controllerData['placeHolder']"
    class="form-control modalClose-focus"
    [value]="controllerData['value']"
    [required]="controllerData['required']"
    (keyup.enter)="validateInput()"
    (blur)="validateInput()"
    [maxlength]="controllerData['maxlength']"
    inputmode="numeric"
    />


    @if (parent.get(controlName).touched
      &&
      parent.get(controlName).errors ) {
      <div [id]="controlName +'-error'"  class="form-validation-error"
        >
        <i class="icon icon-error" aria-hidden="true"></i>
        @if (parent.get(controlName).touched
          &&
          parent.get(controlName).hasError('notValidPhone')) {
          <p [id]="controlName +'-invalid-error'">
            {{controllerData['invalidErrorMessage']}}
          </p>
        }
        @if (parent.get(controlName).touched
          &&
          parent.get(controlName).hasError('required')) {
          <p [id]="controlName +'-invalid-error'">
            {{controllerData['errorMessage']}}
          </p>
        }
        @if (parent.get(controlName).touched
          &&
          !parent.get(controlName).hasError('notValidname')
          &&
          parent.get(controlName).errors.pattern) {
          <p>{{controllerData['invalidErrorMessage']}}</p>
        }
      </div>
    }


  </div>